export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15090.761576ae.jpg";